// 质量报告单-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :type="editViewType" :processId="processId" :_dataId.sync="dataId"
          :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="addButton" status="primary" class="button-sty" icon="el-icon-plus"
                    @click="openEditDialog(0, 'add')">新增
                  </vxe-button>
                  <vxe-button v-if="wkQualityReportExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="报告单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.reportNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="工单编号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="网点名称:" field="name">
                    <template v-slot>
                      <site-search :site-id.sync="formData.siteId"/>
<!--                      <el-input v-model="formData.siteName" size="small" style="width:9vw ;" clearable />-->
                      <!-- <el-input v-model="formData.siteName" size="small" style="width:9vw ;" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>
                      </el-input> -->
                      <!-- <el-autocomplete class="inline-input" style="width:9vw ;" v-model="formData.orderNo"
                        :fetch-suggestions="querySiteSearch" placeholder="" :trigger-on-focus="false"
                        @select="handleSiteSelect" /> -->
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="物流单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.logisticsNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 16vw;" v-model="formData.createTimeList" type="daterange" align="right"
                                      unlink-panels range-separator="-" start-placeholder="开始日期"
                                      end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
<!--                      <el-date-picker style="width: 17vw;" v-model="formData.createTimeList" type="daterange" align="right"-->
<!--                                      unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"-->
<!--                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>-->
<!--                      </el-date-picker>-->
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="产品编码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.itemCode" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="产品条码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.barcode" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="流程节点:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.flowStatStr" filterable clearable style="width:9vw!important ;">
                        <el-option value="发起" label="发起"></el-option>
                        <el-option value="驻外服务经理审批" label="驻外服务经理审批"></el-option>
                        <el-option value="技术支持科审批" label="技术支持科审批"></el-option>
                        <el-option value="品控中心审批" label="品控中心审批"></el-option>
                        <el-option value="服务支持负责人审批" label="服务支持负责人审批"></el-option>
                        <el-option value="配件负责人审批" label="配件负责人审批"></el-option>
                        <el-option value="发起人确认" label="发起人确认"></el-option>
                        <el-option value="结束" label="结束"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="地区:" field="name">
                    <template>
                      <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" style="width:100%;"
                        @change="handleChange" ref="cascader" :options="areaOption">
                      </el-cascader>
                    </template>
                  </vxe-form-item>






                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color" v-if="item.name !== '所有'">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>

            <!-- <template #stat="{ row }">
              <span v-if="row.stat == 1">制单</span>
              <span v-else-if="row.stat == 2">审核中</span>
              <span v-else-if="row.stat == 5">已审核</span>
              <span v-else-if="row.stat == 6">驳回</span>
              <span v-else-if="row.stat == 99">取消</span>
              <span v-else></span>
            </template> -->

            <template #option="{ row }">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row, 'edit')">
                <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                  <i class="el-icon-edit" />
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a" v-if="(row.stat == 1)&&submitButton && !row.processId">提交</el-dropdown-item>
                  <el-dropdown-item command="b" v-if="row.stat == 2&&checkButton && !row.processId">审核</el-dropdown-item>
                  <el-dropdown-item command="c" v-if="row.stat == 2&&rejectButton && !row.processId">驳回</el-dropdown-item>
                  <el-dropdown-item command="d" v-if="(row.stat == 1||row.stat == 6)&&cancelButton && !row.processId">取消</el-dropdown-item>
                  <el-dropdown-item command="e" v-if="row.stat == 1 && !row.processId">启动流程</el-dropdown-item>
                  <el-dropdown-item command="f" v-if="row.processId!=null">查看流程</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showPicDialog"
      title="流程图">
      <img v-if="showPicDialog" :src="actPicUrl" width="100%">
    </el-dialog>

  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
// 假数据
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'
export default {
  name: 'report',
  inject: ['reload'],
  components: {SiteSearch, editView, pager, },
  data() {
    return {
      actPicUrl:"",
      showPicDialog:false,
      addButton:  false,
      editButton:  false,
      wkQualityReportExport: false,

      total: 0,
      editViewType: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],

      areaOption: [],
      areaValues: [],

      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        reportNo: null,
        orderNo: null,
        siteName: null,
        logisticsNo: null,
        barcode: null,
        itemCode: null,

        flowStatStr: null,
        areaIdPath: null,

        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createTimeBegin: null,
        createTimeEnd: null,
        outType: null,
        deliverMan: null,
        deliverMobile: null,
        deliverNo: null,
        checkDateBegin: null,
        checkDateEnd: null,
        createTimeList: null,

        fuzzySearchIsEnable: true,
        fuzzySearchValue: null,
      },

      formData: {
        reportNo: null,
        orderNo: null,
        siteName: null,
        logisticsNo: null,
        barcode: null,
        itemCode: null,

        flowStatStr: null,
        areaIdPath: null,

        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createTimeList: [],
        outType: null,
        deliverMan: null,
        deliverMobile: null,
        deliverNo: null,
        checkDate: null,
        fuzzySearchValue: null
      },

      sitePromptList: [],
      dialogVisible: false,
      dialogMsg: null,
      currentRow: null,
      statName: null,
      goodsStatusList: [ //循环列表
        { name: "制单", num: 0 },
        { name: "审核中", num: 0 },
        { name: "驳回", num: 0 },
        { name: "全部", num: 0 },
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '报告单号', field: 'reportNo', width: 180, slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span style="color: blue"
                  onClick={($event) => this.showInfo(row, $event)}>{row.reportNo}</span>
              ]
            }
          }
        },
        {
          title: '状态', field: 'stat', width: 125, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral">
                    <span>审核中</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status">
                    <span>已审核</span>
                  </div>
                ];
              } else if (row.stat == 6) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '类型', field: 'reportTypeName', width: 100, },
        { title: '服务机构', field: 'orgName', width: 100, },
        { title: '服务商', field: 'siteName', width: 100, },
        { title: '用户姓名', field: 'userName', width: 100, },
        {
          title: '地址(省 市 区)', field: 'area', width: 235, slots: {
            default: ({ row }) => {
              return [<span>{row.userProvince}{row.userCity}{row.userCounty}{row.userTown}</span>]
            }
          }
        },
        { title: '产品大类', field: 'bigCategoryName', width: 80, },
        { title: '产品条码', field: 'barcode', width: 150, },
        { title: '产品名称', field: 'itemName', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },


      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.getTableData()
    //   }
    // },

  },
  created() {
    this.addButton = this.permissions["wkQualityReportAdd"];
    this.editButton = this.permissions["wkQualityReportEdit"];
    this.wkQualityReportExport = this.permissions["wkQualityReportExport"];
    this.submitButton= this.permissions["wkQualityReportSubmit"]; //提交
    this.checkButton= this.permissions["wkQualityReportCheck"]; //审核
    this.rejectButton= this.permissions["wkQualityReportReject"]; //驳回
    this.cancelButton= this.permissions["wkQualityReportCancel"]; //取消
  },

  mounted() {
    this.initSearchDate()
    this.loadTabOption()
  },

  methods: {
    toFilterData() {
            this.searchEvent();
     },

     // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userTown = null;
          this.formData.userCounty = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        // this.formData.areaId = areaNode[0].value
        this.formData.areaIdPath = areaNode[0].path.join("/")
      } else {
        this.formData.areaId = null;
        this.formData.areaIdPath = null
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }
      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }
    },
    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    
    // tab也切换为列表页
    goBackIndex() {
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },
    confirm() {
      this.$mask.open()

      this.$http({
        url: api.wkQualityReport.confirmDataUrl,
        method: 'post',
        data: {
          id: this.currentRow.id,
          statName: this.statName
        }
      }).then(res => {
        //this.$message.success('操作成功');
        if (res.data.type == "success") {
          this.$message({message: res.data.content, type: 'success'});

        } else {
          this.$message({message: res.data.content, type: 'warning'});
        }
        this.flushed()
      })
      this.dialogVisible = false
      this.$mask.close()

    },
    flushed() {
      this.loadTabOption()

      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createTimeList = [start, end]
      this.requestParam.createTimeList = [start, end]
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'get',
        data: { userName: queryStr }
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({ value: item.userName, id: item.id })
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {
      console.log("this.requestParam",this.requestParam)
      this.$http({
        url: api.wkQualityReport.getCountUrl,
        method: 'get',
        params: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      let s = null
      if (item.name === '制单') {
        s = 1
      } else if (item.name === '审核中') {
        s = 2
      } else if (item.name === '驳回') {
        s = 6
      }
      this.requestParam.stat = s
      this.formData.stat = s
      this.flushed()

    },


    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.wkQualityReport.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        // fakeData: {
        //   total: 0,
        //   list: [
        //     { id: 1, applyNo: 'QR2023568963578',serverTypeName:'维修',stat:'2', createBy:'李先生',userMobile:'17688888888',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'2',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 2, applyNo: 'QR2023568965659',serverTypeName:'维修',stat:'5', createBy:'王先生',userMobile:'17677777777',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'1',userProvice:'广东省',userCity:'佛山市',userTown:'乐从镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 3, applyNo: 'QR2023568963565',serverTypeName:'维修',stat:'6', createBy:'杨先生',userMobile:'17622222222',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'3',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 4, applyNo: 'QR2023568965659',serverTypeName:'维修',stat:'2', createBy:'张先生',userMobile:'17611111111',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'2',userProvice:'广东省',userCity:'佛山市',userTown:'顺德区',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 5, applyNo: 'QR2023568963577',serverTypeName:'维修',stat:'5', createBy:'李先生',userMobile:'17688888888',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'1',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 6, applyNo: 'QR2023568965659',serverTypeName:'维修',stat:'2', createBy:'李先生',userMobile:'17699999999',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'2',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 7, applyNo: 'QR2023568963544',serverTypeName:'维修',stat:'5', createBy:'刘先生',userMobile:'17688888888',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'3',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //     { id: 8, applyNo: 'QR2023568965659',serverTypeName:'维修',stat:'6', createBy:'李先生',userMobile:'17600000000',brandName:'洲明',bigCategoryName:'多媒体',guaranteeType:'2',userProvice:'广东省',userCity:'佛山市',userTown:'北滘镇',orgName:'广东大区',siteName:'顺德网点',recallStat:'2',siteComplainStat:'家电',createBy2:'空调',createTime:'2023-07-05'},
        //   ]
        // },
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      // this.requestParam.fuzzySearchIsEnable = !this.showMoreOptions

      // let formData = this.formData
      //
      // this.requestParam.fuzzySearchValue = formData.fuzzySearchValue
      // this.requestParam.stat = formData.stat
      // this.requestParam.orgId = formData.orgId
      // this.requestParam.siteId = formData.siteId
      // this.requestParam.applyType = formData.applyType
      // this.requestParam.outType = formData.outType
      // this.requestParam.deliverMan = formData.deliverMan
      // this.requestParam.deliverMobile = formData.deliverMobile
      // this.requestParam.deliverNo = formData.deliverNo
      //
      //
      // this.requestParam.reportNo = formData.reportNo
      // this.requestParam.orderNo = formData.orderNo
      // this.requestParam.siteName = formData.siteName
      // this.requestParam.logisticsNo = formData.logisticsNo
      // this.requestParam.barcode = formData.barcode
      // this.requestParam.itemCode = formData.itemCode
      //
      // this.requestParam.createTimeBegin = ''
      // this.requestParam.createTimeEnd = ''
      // if (formData.createTime !== null && formData.length !== 0) {
      //   this.requestParam.createTimeBegin = formData.createTime[0]
      //   this.requestParam.createTimeEnd = formData.createTime[1]
      // }
      //
      // this.requestParam.checkDateBegin = ''
      // this.requestParam.checkDateEnd = ''
      // if (formData.checkDate !== null && formData.checkDate.length !== 0) {
      //   this.requestParam.checkDateBegin = formData.checkDate[0]
      //   this.requestParam.checkDateEnd = formData.checkDate[1]
      // }

      this.$objCopy(this.formData, this.requestParam)

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 操作
    handleCommand(command, row) {
      this.currentRow = row
      console.log(command, row, "command,b的值");
      if (command === 'a') { //提交
        //this.openEditDialog(row.id, 'submit')
        this.dialogMsg = '确定提交吗？'
        this.statName = '提交'
        this.dialogVisible = true
      } else if (command === 'b') { //审核
        //this.openEditDialog(row.id, 'check')
        this.dialogMsg = '确定审核吗？'
        this.statName = '审核'
        this.dialogVisible = true
      } else if (command === 'c') { //驳回
        //this.openEditDialog(row.id, 'reject')
        this.dialogMsg = '确定驳回吗？'
        this.statName = '驳回'
        this.dialogVisible = true
      } else if (command === 'd') { //取消
        //this.openEditDialog(row.id, 'cancel')
        this.dialogMsg = '确定取消吗？'
        this.statName = '取消'
        this.dialogVisible = true
      }else if(command === 'e') {//启动流程
        this.$mask.open()

        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: {id: row.id, tableKey: "WkQualityReport", orgId: row.orgId, orderNo: row.reportNo},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
        })
      } else if (command === 'f') { //查看流程
        this.actPicUrl = `/act/wf/wfview/` + row.processId
        this.showPicDialog = true
      }
      this.$mask.close()

    },


    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row, 'info')
    },

    // 新增/修改
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },



    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.wkQualityReport).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.wkQualityReport.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}


::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
